import React from "react";
import { Box, Heading } from "grommet";
import { useNavigate, useParams } from "react-router-dom";
// import { LinkPrevious } from "grommet-icons";

const BreadcrumbNavigation = ({ current, previous}) => {
  const navigate = useNavigate();
  const {manager_id} = useParams();

  return (
    <Box>
      <Heading level="2" margin="none">
        <span
            style={{ cursor: "pointer" }}
            onClick={() => {
                if (previous !== "Manage Assessments") {
                navigate(-1);
                } else {
                navigate(`/${manager_id}/manager/assessments`);
                }
            }}
            >
            {previous}
            </span>
        {previous && current && " / "}
        <span
        //   style={{ cursor: "pointer" }}
        //   onClick={() => navigate(`${current_link}`)}
        >
          {current}
        </span>
      </Heading>
    </Box>
  );
};

export default BreadcrumbNavigation;